import AboutSection from "../../components/marketing/AboutSection";
import BenefitsSection from "../../components/marketing/BenefitsSection";

const FeaturesPage = () => {
  return (
    <div className="assist">
      <AboutSection />
      <BenefitsSection />
    </div>
  );
};

export default FeaturesPage;